'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.h2.withConfig({
  componentId: 'llx9ae-0'
})(['border-radius:', ';padding:calc(', ' / 2) calc(', ' / 1);'], function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.spacingUnit;
});